var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.458 4.03281C27.066 2.12709 22.934 2.12708 19.542 4.03281L6.96576 11.0986C3.92809 12.8052 3.92807 17.1958 6.96575 18.9024L19.542 25.9682C22.934 27.8739 27.066 27.8739 30.458 25.9682L43.0342 18.9024C46.0719 17.1958 46.0719 12.8052 43.0342 11.0986L30.458 4.03281Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19826 31.9512C3.95427 33.9095 4.21009 37.6664 6.96575 39.2146L19.542 46.2804C22.934 48.1861 27.066 48.1861 30.458 46.2804L43.0342 39.2146C45.7899 37.6664 46.0457 33.9095 43.8017 31.9512L31.9886 38.5881C27.6461 41.0279 22.3539 41.0279 18.0114 38.5881L6.19826 31.9512Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85871 21.8652C3.98891 23.8902 4.35791 27.3334 6.96575 28.7986L19.542 35.8644C22.934 37.7701 27.066 37.7701 30.458 35.8644L43.0342 28.7986C45.6421 27.3334 46.0111 23.8902 44.1413 21.8652L31.9886 28.693C27.6461 31.1328 22.3539 31.1328 18.0114 28.693L5.85871 21.8652Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.e8d600e8881e182fa190faff22f6a785.svg";
export { ForwardRef as ReactComponent };